export const NUM_OF_PEOPLE_ERROR_MESSAGE =
  '参加人数（大人・子供・幼児の合計）は1名以上にしてください'

// hasAtLeastOnePerson : 大人・子供・幼児の合計が1名以上か. 空文字・非数値はNG扱いになる.
export const hasAtLeastOnePerson = (
  adults: string | number,
  children: string | number,
  infants: string | number
): boolean => Number(adults) + Number(children) + Number(infants) >= 1

// toNonNegativeInteger : 0 以上の整数へ変換する. 空文字・非数値・負数・小数は 0 を返す.
export const toNonNegativeInteger = (value: string | number): number => {
  const parsed = Number(value)
  if (!Number.isInteger(parsed) || parsed < 0) {
    return 0
  }
  return parsed
}
